var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.view_action != null
    ? _c(
        "div",
        { staticClass: "vacation_info" },
        [
          _c(
            "b-badge",
            {
              staticClass: "border border-primary",
              attrs: { variant: "border-primary" },
            },
            [
              _vm._v(
                "\n        Переглянув " + _vm._s(_vm.added_text) + "\n    "
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }